<template lang="html">
  <img :src="srcImg ? srcImg : srcLoader" :class="{ loader: !srcImg }" ref="img" />
</template>

<script>
import LazyLoadImage from '@/components/core/lazy-load-image'

export default {
  name: 'BimImg',
  mixins: [LazyLoadImage],
  props: {
    /**
     * src изображения
     */
    src: {
      type: [String],
      default: ''
    }
  },
  data () {
    return {
      lazyImgSrcKey: 'src' // по какому ключу лежит src картинки
    }
  }
}
</script>

<style lang="scss" scoped>
  img {
    display: block
  }
  .loader {
    max-width: 24px !important
  }
</style>
